import {useNavigate} from "react-router-dom";
import {useCallback} from "react";
import {urls} from "~/routes/consumerUrls";
import NiceModal from "@ebay/nice-modal-react";
import ContactUsDialog from "~/components/contact-us/ContactUsDialog";
import {useAuth} from "@bounce/shared/contexts";
import {KEY_OPEN_MANAGE_CONTACT_DIALOG} from "~/constants/no-login-keys";
import {BounceRole} from "@bounce/shared/consumer/declarations";
import {isPreLoginRole} from "~/helpers/roles";
import ContactMethodsDialog from "../../dialogs/ContactMethodsDialog";
import {useConsumerMenu} from "../../context/MenuContext";

export const useSupportActions = () => {
  const {clearCredentials, loggedIn, userId, userRole} = useAuth();
  const {trackAndCloseMenu} = useConsumerMenu();
  const navigate = useNavigate();

  const shouldDisplaySupportOptions = (loggedIn && !!userId) || isPreLoginRole(userRole);

  const onLogout = useCallback(() => {
    trackAndCloseMenu("logout");
    clearCredentials();
    const targetUrl = userId ? `${urls.login.url}?id=${userId}` : urls.login.url;
    navigate(targetUrl);
  }, [trackAndCloseMenu, clearCredentials, userId, navigate]);

  const onSupportClick = useCallback(async () => {
    trackAndCloseMenu("get_support");
    await NiceModal.show(ContactUsDialog, {fetchContact: loggedIn});
  }, [trackAndCloseMenu]);

  const onManageContactClick = useCallback(async () => {
    trackAndCloseMenu("manage_contact");

    if (userRole === BounceRole.NO_LOGIN_USER) {
      sessionStorage.setItem(KEY_OPEN_MANAGE_CONTACT_DIALOG, "true");
      const userIdQuery = userId ? `?id=${userId}` : "";
      navigate(urls.login.url + userIdQuery, {state: {globalLogin: true}});
    } else {
      await NiceModal.show(ContactMethodsDialog, {});
    }
  }, [trackAndCloseMenu, userRole, navigate]);

  return {onLogout, onSupportClick, onManageContactClick, shouldDisplaySupportOptions};
};
